const customerRawMaterials = [
    {
        "uuid": "1",
        "customerNo": "0001",
        "customerName": "源天然股份有限公司",
        "assessmentPlace": "高雄廠",
        "productName": ["杏仁玄米餅", "核桃酥"],
        "tseyueLevel": "clean",
        "leezenLevel": "organic",
        "productStatus": "approve",
        "rawMaterialName": "豆蓉粉(新版)",
        "channel": "leezen",
        "processStatus": "frontEnd",
        "backEndProductName": ["杏仁玄米餅", "核桃酥"],
        "type": "material",
        "composition":"水、非基因改造脫脂黃豆片、小麥、食鹽、轉化液糖(蔗糖、水)、調味劑(DL-蘋果酸)",
        "domesticVendor":"穎昌食品有限公司(新和美)",
        "importer":"信成股份有限公司",
        "manufacturer":"穎昌食品有限公司(新和美)",
        "originPlace":"台灣",
        "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
        "addRatio":9,
        "storageCondition": "roomTemperature",
    },
    {
        "uuid": "2",
        "customerNo": "0001",
        "customerName": "源天然股份有限公司",
        "assessmentPlace": "高雄廠",
        "productName": ["杏仁玄米餅", "核桃酥"],
        "tseyueLevel": "doubleClean",
        "leezenLevel": "excellent",
        "productStatus": "improvement",
        "rawMaterialName": "美國加州杏仁果",
        "channel": "leezen",
        "processStatus": "frontEnd",
        "backEndProductName": ["杏仁玄米餅", "核桃酥"],
        "type": "material",
        "composition":"水、非基因改造脫脂黃豆片、小麥、食鹽、轉化液糖(蔗糖、水)、調味劑(DL-蘋果酸)",
        "domesticVendor":"穎昌食品有限公司(新和美)",
        "importer":"信成股份有限公司",
        "manufacturer":"穎昌食品有限公司(新和美)",
        "originPlace":"台灣",
        "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
        "addRatio":9,
        "storageCondition": "roomTemperature",
    },
    {
        "uuid": "3",
        "customerNo": "0001",
        "customerName": "源天然股份有限公司",
        "assessmentPlace": "高雄廠",
        "productName": ["Pasta義大利麵", "桂圓四物飲"],
        "tseyueLevel": "allNature",
        "leezenLevel": "good",
        "productStatus": "suspend",
        "rawMaterialName": "有機生糙米粉(台灣)",
        "channel": "leezen",
        "processStatus": "frontEnd",
        "backEndProductName": ["Pasta義大利麵", "桂圓四物飲"],
        "type": "material",
        "composition":"水、非基因改造脫脂黃豆片、小麥、食鹽、轉化液糖(蔗糖、水)、調味劑(DL-蘋果酸)",
        "domesticVendor":"穎昌食品有限公司(新和美)",
        "importer":"信成股份有限公司",
        "manufacturer":"穎昌食品有限公司(新和美)",
        "originPlace":"台灣",
        "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
        "addRatio":9,
        "storageCondition": "roomTemperature",
    },
]

export default customerRawMaterials;